module.exports = __webpack_public_path__ + "img/simulation-wap.8cf57f02.png";